import { useDemoCtx } from './DemoContext';
import { IrrForm } from './panels/IrrForm';

const RECORDS = [
    { date: '2026.01.15 09:30', site: '용산 미군기지 단지', mgr: '김관리자', type: '긴급 관수 시행', badge: 'danger', badge_txt: '긴급', amt: '1,240L', method: '점적관수', mins: '75분' },
    { date: '2026.01.14 14:00', site: '강동 천호공원 A',    mgr: '박현장',   type: '정기 관수',     badge: 'good',   badge_txt: '완료', amt: '890L',   method: '스프링클러', mins: '50분' },
    { date: '2026.01.12 10:00', site: '서초 가로수길 단지', mgr: '이담당',   type: '정기 관수',     badge: 'good',   badge_txt: '완료', amt: '420L',   method: '수동',       mins: '30분' },
    { date: '2026.01.10 08:00', site: '마포 홍대 가로공원', mgr: '김관리자', type: '예방 관수',      badge: 'caution', badge_txt: '완료', amt: '350L',  method: '스프링클러', mins: '25분' },
];

export default function DemoIrrigation() {
    const { openPanel } = useDemoCtx();

    const openIrr = (site = '전체') => openPanel({
        title: '관수 등록',
        body: <IrrForm siteName={site} />,
    });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
            <div className="list-bar">
                <div style={{ fontSize: 13.5, fontWeight: 800 }}>관수 관리</div>
                <div style={{ flex: 1 }} />
                <select className="form-select" style={{ width: 160, height: 32, fontSize: 12 }}>
                    <option>전체 단지</option>
                    <option>송파 올림픽공원</option>
                    <option>용산 미군기지</option>
                </select>
                <input type="date" className="form-input" style={{ height: 32, width: 155, fontSize: 12 }} />
                <button className="btn btn-primary btn-sm" onClick={() => openIrr()}>＋ 관수 등록</button>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: 20 }}>
                <div className="timeline">
                    {RECORDS.map((r, i) => (
                        <div key={i} className={`tl-item fade-up d${i}`}>
                            <div className="tl-dot">💧</div>
                            <div className="tl-body">
                                <div className="tl-meta">{r.date} · {r.site} · {r.mgr}</div>
                                <div className="tl-card">
                                    <div className="tl-card-top">
                                        <span className="tl-card-name">{r.type}</span>
                                        <span className={`badge badge-${r.badge}`}>{r.badge_txt}</span>
                                    </div>
                                    <div className="tl-stats">
                                        <div className="tl-stat"><div className="tl-stat-lbl">관수량</div><div className="tl-stat-val">{r.amt}</div></div>
                                        <div className="tl-stat"><div className="tl-stat-lbl">방법</div><div className="tl-stat-val" style={{ fontSize: 11 }}>{r.method}</div></div>
                                        <div className="tl-stat"><div className="tl-stat-lbl">시간</div><div className="tl-stat-val">{r.mins}</div></div>
                                    </div>
                                    <button className="btn btn-secondary btn-sm" style={{ marginTop: 8 }} onClick={() => openIrr(r.site)}>💧 이 단지 관수 등록</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
